import { render, staticRenderFns } from "./BxKuncunInfoModal__Style#Drawer.vue?vue&type=template&id=71ad035a&scoped=true&"
import script from "./BxKuncunInfoModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BxKuncunInfoModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BxKuncunInfoModal__Style#Drawer.vue?vue&type=style&index=0&id=71ad035a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad035a",
  null
  
)

export default component.exports